/*
 * Keep the Edit popup's quantity in step with the drawer.
 *
 * Symptom: set a line to 2 with the drawer's + button, tap the pencil, and the
 * popup opens showing 1. Close it, open it again, and now it says 2.
 *
 * The popup gets its quantity from an attribute on the pencil, not from the
 * cart. theme.js does this:
 *
 *     quantity = $target.data('edit-cart-quantity'),
 *     ...
 *     productItem.find('input[name="quantity"]').val(quantity);
 *
 * It has to. The form is fetched from the *product* URL
 * ({{ item.url }}&view=ajax_edit_cart), which knows the product but not which
 * cart line is being edited - confirmed by fetching that URL directly while the
 * cart held 2 of the item: the server renders 1. So the attribute is the only
 * carrier of the line's quantity, and Liquid stamps it when the drawer renders.
 *
 * Round 2 is what left it behind. Before that, every quantity change re-rendered
 * the whole drawer, which happened to restamp the attribute. Round 2 made the
 * common case update in place instead - deliberately, because the full re-render
 * was throwing away scroll position and reloading every thumbnail on each tap.
 * The visible number, the prices and the totals are all updated in place; this
 * one attribute was not, so it kept the value from whenever the drawer was last
 * rendered. Measured: drawer input 2, cart API 2, attribute still 1.
 *
 * The second-open-shows-2 half of the report is the same fact from the other
 * side: closing the popup re-renders the drawer, the attribute is restamped
 * correctly, and the next open reads a fresh one.
 *
 * The cart page does not have this bug - its quantity changes go through a full
 * section re-render, so its attribute is always current (verified: 2 / 2 / 2).
 * This still listens document-wide rather than drawer-only, so the cart page
 * stays right if it ever gains the same fast path.
 *
 * Fix: read the quantity at the moment the pencil is clicked, from what the
 * shopper is actually looking at, and write it into the attribute before the
 * theme reads it. Reading a single source at the moment of use cannot drift;
 * keeping a second copy in sync is what drifted in the first place.
 */
(function () {
  /* The line's quantity, preferring the number on screen so the popup can never
     disagree with the drawer the shopper is looking at - including while an
     optimistic update from round 2 is still in flight. */
  function liveQuantity(button) {
    var row = button.closest('[data-item-row]');
    if (row) {
      var input = row.querySelector('input.quantity, input[name="quantity"]');
      if (input) {
        var shown = parseInt(input.value, 10);
        if (shown > 0) return shown;
      }
    }

    /* No input on screen (a line rendered without a stepper, say) - fall back to
       the cart snapshot the free-gift sync keeps on window, matched by line key. */
    var key = button.getAttribute('data-line');
    var cart = window.__civiaCartSnapshot;
    if (key && cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) return cart.items[i].quantity;
      }
    }

    return null;
  }

  /*
   * Capture phase. The theme's handler is delegated on document
   * ($doc.on('click', '[data-open-edit-cart]', ...)), so it runs in the bubble
   * phase; a capture listener on the same node is guaranteed to have written the
   * attribute before that handler reads it.
   */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('[data-open-edit-cart]');
    if (!button) return;

    var quantity = liveQuantity(button);
    /* Nothing trustworthy to say - leave the theme exactly as it was. */
    if (quantity === null) return;

    button.setAttribute('data-edit-cart-quantity', quantity);

    /*
     * jQuery caches data-* attributes on first read and ignores later writes to
     * the attribute, so setAttribute alone would still hand the theme the stale
     * value on every open after the first. Writing through jQuery updates that
     * store as well. Guarded because this file must not require jQuery.
     */
    if (window.jQuery) {
      window.jQuery(button).data('edit-cart-quantity', quantity);
    }
  }, true);
})();
